import { Action, ActionType, PageType, State } from "../types";

export const handleReviewDetails = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.REVIEW_DETAILS_ABOUT_YOU_UPDATE_DETAILS_CLICKED: {
      return {
        ...state,
        page: PageType.ABOUT_YOURSELF,
      };
    }

    case ActionType.REVIEW_DETAILS_INCOME_AND_EXPENSES_UPDATE_DETAILS_CLICKED: {
      return {
        ...state,
        page: PageType.INCOME_AND_EXPENSES,
      };
    }

    case ActionType.REVIEW_DETAILS_VERIFIER_TERMS_CLICKED: {
      return {
        ...state,
        page: PageType.VERIFIER_TERMS,
      };
    }

    case ActionType.REVIEW_DETAILS_PENDING_POI: {
      return {
        ...state,
        page: PageType.PROOF_OF_INCOME,
        bankConnectUrl: action.bankConnectUrl,
      };
    }

    case ActionType.REVIEW_DETAILS_CLI_PENDING_CUST_CALL: {
      return {
        ...state,
        page: PageType.ASSESSED,
      };
    }

    case ActionType.REVIEW_DETAILS_BACK_CLICKED: {
      return {
        ...state,
        page: PageType.INCOME_AND_EXPENSES,
      };
    }

    case ActionType.SUBMIT_APPLICATION_FAILED: {
      return {
        ...state,
        page: PageType.ERROR,
      };
    }

    case ActionType.FINAL_DECLINE: {
      return {
        ...state,
        page: PageType.FINAL_DECLINE,
      };
    }

    case ActionType.UNABLE_TO_INCREASE: {
      return {
        ...state,
        page: PageType.UNABLE_TO_INCREASE,
      };
    }

    case ActionType.READY_TO_CONFIRM_MMP: {
      return {
        ...state,
        page: PageType.CONFIRM_MMP,
        newCreditLimit: String(action.approvedCreditLimit / 100),
        requestedCreditLimit: action.requestedCreditLimit / 100,
        acknowledgementUrl: action.acknowledgementUrl,
        bankConnectUrl: action.bankConnectUrl,
        expiryDate: action.expiryDate,
        cancelUrl: action.cancelUrl,
        latitudePoiUrl: action.latitudePoiUrl,
        isConditionallyApproved: action.isConditionallyApproved,
      };
    }

    case ActionType.CLI_NOT_ELIGIBLE: {
      return {
        ...state,
        page: PageType.UNABLE_TO_INCREASE,
        accountInfo: action.accountInfo,
      };
    }

    default: {
      return state;
    }
  }
};
